import { Cell } from "./Table.props";


const DefaultArrowCellStyle = ():Cell => {
  return { align: "center", pl: "0.1rem", pr: "0rem", width:"5%" };
};

export default DefaultArrowCellStyle;
